import {
  INSURANCE_ADDED,
  INSURANCE_DELETED,
  INIT_INSURANCES,
  TOGGLE_TERMS,
} from 'Store/booking/proposals/constants';
export type InsuranceState = {
  termsChecked: boolean;
  isAdded: boolean;
  isDeleted: boolean;
};
const initialState = {};
export const insuranceReducer = (state: InsuranceState = initialState, action: Action<{}>) => {
  const payload = action.payload;

  switch (action.type) {
    case INIT_INSURANCES:
      return payload;

    case INSURANCE_ADDED:
      return {
        ...state,
        // @ts-expect-error TODO(flow-migration)
        [payload]: {
          // @ts-expect-error TODO(flow-migration)
          ...state[payload],
          isDeleted: false,
          isAdded: true,
        },
      };

    case INSURANCE_DELETED:
      return {
        ...state,
        // @ts-expect-error TODO(flow-migration)
        [payload]: {
          // @ts-expect-error TODO(flow-migration)
          ...state[payload],
          isAdded: false,
          isDeleted: true,
        },
      };

    case TOGGLE_TERMS:
      return {
        ...state,
        // @ts-expect-error TODO(flow-migration)
        [payload]: {
          // @ts-expect-error TODO(flow-migration)
          ...state[payload],
          // @ts-expect-error TODO(flow-migration)
          termsChecked: !(state[payload] && state[payload].termsChecked),
        },
      };

    default:
      return state;
  }
};
